// eslint-disable react-hooks/exhaustive-deps
import * as React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { routes } from "../routes/routes";
import { toast } from "react-toastify";
import { Login as LoginAPI } from "../services/auth";
import { LogoutApi } from "../services/logout";
import { GetUserRolesRights } from "../services/admin";
import { useDispatch } from "react-redux";
import { setRolesAndRights } from "../redux/role-rights/Action";
import {
  GetEpoModulesCounts,
} from "../services/expense-purchase-order";
import { GetAllDocuments } from "../services/document-management/index";
import { GetNotification } from "../services/dashboard";
interface LoginInterface {
  name: string;
  password: string;
}

interface AuthContextType {
  user: any;
  login: (user: LoginInterface) => void;
  logout: any;
  getEpoModulesCounts: any;
  MPCVoteCount: any;
  mpcAllVoteForEpoCount: any;
  documentAwaitingCount: any;
  getNotifications: any;
  notifications: any;
  getAllDocuments: any;
}

let AuthContext = React.createContext<AuthContextType>(null!);

// Helper to get user from localStorage synchronously
// const getStoredUser = () => {
//   try {
//     const userObj = localStorage.getItem("user");
//     return userObj ? JSON.parse(userObj) : null;
//   } catch {
//     return null;
//   }
// };

export function AuthProvider({ children }: { children: React.ReactNode }) {
  let location = useLocation();
  let navigate = useNavigate();
  let dispatch = useDispatch();

  let [user, setUser] = React.useState<any>(null);
  // let [user, setUser] = React.useState<any>(getStoredUser);
  const [MPCVoteCount, setMPCVoteCount] = React.useState<any>(null);
  const [myApprovalCount, setMyApprovalCount] = React.useState<any>(null);
  const [mpcAllVoteForEpoCount, setMpcAllVoteForEpoCount] = React.useState<any>(null);
  const [notifications, setNotifications] = React.useState<any>(null);
  const [documentAwaitingCount, setDocumentAwaitingCount] = React.useState<any>(null);

  React.useEffect(() => {
    if(routes.resetPassword.match ===location.pathname ||  location.pathname.includes("view-fto-viaemail") ){
      localStorage.clear(); 
    }
  }, [location?.pathname]);

  React.useEffect(() => {
    const userObj = localStorage.getItem("user");
    const user = userObj ? JSON.parse(userObj) : null;
    if (user) {
      getEpoModulesCounts();
      getAllDocuments();
      getNotifications();
      setUser(user);
      if (location?.search) {
        navigate(
          location.pathname
            ? location.pathname + location.search
            : routes.dashboard.match
        );
      } else
        navigate(
          location.pathname ? location.pathname : routes.dashboard.match
        );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getAllDocuments = async () => {
    const data = {
      data: {
        documentType: null,
        approvalData: true,
        isSendForApproval: true,
      },
      start: 1,
      length: 5,
      sortExpression: 'id desc',
      searchKeyword: null,
    };
    try {
      const response = await GetAllDocuments(data);
      if (response?.status === 200) {
        setDocumentAwaitingCount(response?.data?.totalRecords);
      }
    } catch (e) {}
  };

  const getEpoModulesCounts = async () => {
    const response = await GetEpoModulesCounts();
    setMPCVoteCount(response.data.mpcVoteForEpoCount);
    setMyApprovalCount(response.data.myApprovalCount);
    setMpcAllVoteForEpoCount(response.data.mpcAllVoteForEpoCount);
  };

  const getNotifications = async () => {
    const response = await GetNotification();
    if (response?.status === 200) {
      setNotifications(response?.data);
    }
  };

  const login = async (newUser: LoginInterface) => {
    let key = process.env.REACT_APP_URL;
    try {
      let response = await LoginAPI(newUser?.name, newUser?.password);
      if (response?.status === 200) {
        setUser(newUser);
        localStorage.setItem("user", JSON.stringify(newUser));
        // Set user token in local storage
        localStorage.setItem(
          `userToken_${key}`,
          JSON.stringify(response?.data?.authToken)
        );
        localStorage.setItem("encryptedUserId", response?.data?.encryptedUserId);

        getUserRights();
        navigate(routes?.dashboard.match);
      } else {
        navigate(routes?.login.match);
      }
    } catch (e) {
      toast.error("Username or password is incorrect.");
    }
  };

  const logout = async () => {
    const response = await LogoutApi();
    if (response?.status === 200) {
      setUser(null);
      localStorage.clear();
      navigate(routes?.login?.match);
      toast.success("Successfully logout");
    }
  };

  const getUserRights = async () => {
    localStorage.removeItem("userPermissions");
    try {
      const response = await GetUserRolesRights();
      if (response?.status === 200) {
        localStorage.setItem("userPermissions", JSON.stringify(response?.data));
        window.location.reload();
        dispatch(setRolesAndRights(response?.data));
      }
    } catch (e) {}
  };

  let value = {
    user,
    login,
    logout,
    getEpoModulesCounts,
    getNotifications,
    notifications,
    MPCVoteCount,
    myApprovalCount,
    mpcAllVoteForEpoCount,
    documentAwaitingCount,
    getAllDocuments
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  return React.useContext(AuthContext);
}
